import qs from 'qs';
import { handleActions } from 'redux-actions';
import { getFormValues } from 'redux-form';

import endpoints from '../../../config/endpoints';
import { LOCATION_CHANGE, replace } from 'react-router-redux';

import http from '../../shared/http';
import intl from '../../shared/intl';
import checkPermissions from '../../shared/check-permissions';

import moment from 'moment';

import cloneDeep from 'lodash/cloneDeep';
import createFilters from '../../shared/filters';

import {default as createCalendar, getDateRangeFromCalendar} from '../../shared/calendar';

const calendar = createCalendar({
	namespace: 'payoutRequestStat',
	stateNodeName: 'calendar',
	defaultValue: {
		start: moment().subtract(1, 'month').format('YYYY-MM-DD'),
		end: moment().format('YYYY-MM-DD')
	}
});

const filters = createFilters({
	namespace: 'payoutRequestStat',
	stateNodeName: 'filters',
	queryBuildFunc: () => '',
	listOfFilters: [{
		name: 'affiliates',
		title: 'Affiliates',
		placeholder: 'Add affiliates',
		value: [],
		multi: true,
		shouldInverse: false,
		shouldShowInverseControl: false,
		options: {
			type: 'dynamic',
			source: endpoints.LOOKUPS.AFFILIATES
		}
	}, {
		name: 'managers',
		title: 'Managers',
		placeholder: 'Add managers',
		value: [],
		multi: true,
		shouldInverse: false,
		shouldShowInverseControl: false,
		options: {
			type: 'dynamic',
			source: endpoints.LOOKUPS.ADMINS
		}
	}]
});

// action types
const FETCH_DATA_SUCCESS = 'payoutRequestStat/fetch-data-success';
const FETCH_DATA_ERROR = 'payoutRequestStat/fetch-data-error';

const TOGGLE_PROGRESS_BAR = 'payoutRequestStat/toggle-progress-bar';

const APPLY = 'payoutRequestStat/apply';

// permissions
export const allowedPermissions = {
	payout_requests_personal_view: 'payout_requests_personal_view',
	payout_requests_view_all: 'payout_requests_view_all',
	payout_requests_view_matrix_and_history: 'payout_requests_view_matrix_and_history',
	payout_requests_review: 'payout_requests_review',
	payout_requests_manager_role: 'payout_requests_manager_role',
	payout_requests_confirm: 'payout_requests_confirm'
};

const table = {
	columns: {
		name: { index: 'name', className: '', title: 'Name' },
		manager: { index: 'manager', className: '', title: 'Manager' },
		count: { index: 'count', className: '', title: 'count' }
	}
};
// initial state
const initialState = {
	data: null,
	systemBalances: {},
	calendar: calendar.initialState,
	table,
	showProgressBar: false,
	filters: filters.initialState,
	error: false,
	isRequestFormVisible: false,
	sortedPayoutSystemsList: []
};

// actions
export const actions = Object.assign(
	{
		fetchData: () => (dispatch, getState) => {

			const query = {};
			const { calendar } = getState().payoutRequestStat;
			query.date_range = getDateRangeFromCalendar(calendar);
			const payoutRequestsStatParams = getFormValues('payoutRequestsStatParams')(getState());

			if (payoutRequestsStatParams && payoutRequestsStatParams.is_request_only) {
				query.is_request_only = true;
			}

			return http({
				url: `${endpoints.PAYOUT_REQUESTS.STAT}?${qs.stringify(query)}`,
				method: 'get',
				actions: [FETCH_DATA_SUCCESS, FETCH_DATA_ERROR]
			})(dispatch);
		},

		apply: () => dispatch => {
			dispatch(actions.fetchData());
		},

		clear: () => (dispatch, getState) => {
			dispatch(replace('/payouts/'));
		},
		toggleProgressBar: () => ({
			type: TOGGLE_PROGRESS_BAR
		})
	},
	calendar.actions,
	filters.actions
);

const reducers = Object.assign(
	{
		[LOCATION_CHANGE]: (state, action) => {
			return initialState;
		},
		[FETCH_DATA_SUCCESS]: (state, action) => {
			return {
				...state,
				data: action.payload.data,
				showProgressBar: false,
				error: false
			};
		},
		[APPLY]: (state, action) => {
			return {
				...state,
				selectedFilters: {
					...action.payload
				}
			};
		},
		[FETCH_DATA_ERROR]: state => ({ ...state, error: true, showProgressBar: false }),
		[TOGGLE_PROGRESS_BAR]: state => ({ ...state, showProgressBar: !state.showProgressBar })
	},
	calendar.reducers,
	filters.reducers
);

// reducers
export default handleActions(reducers, cloneDeep(initialState));

// selectors
export const selectors = {
	getData: state => state.payoutRequestStat.data,
	getCalendar: state => calendar.selectors.getCalendar(
		state => state.payoutRequestStat.calendar, state => state
	)(state),
	getProgressBar: state => state.payoutRequestStat.showProgressBar,
	getTable: state => {
		const { table, data } = state.payoutRequestStat;
		return {
			headers: Object.values(table.columns),
			rows: data || []
		};
	},
	getIsRequestFormVisible: state => state.payoutRequestStat.isRequestFormVisible,
	getIntl: state => intl(state),
	getCan: state => checkPermissions(state, allowedPermissions),
	getFilters: state => filters.selectors.getFilters(
		state => state.payoutRequestStat.filters,
		state => state
	)(state),
	getRequestFormInitialValues: state => ({
		currency: 'usd'
	}),
	getError: state => state.payoutRequestStat.error
};



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/payout-requests/list-stat/index.js